import * as React from 'react';
import { useState } from 'react';
import { authUrl } from './../config';
import { useAppDispatch } from '../hooks';
import { signIn } from '../Store/appSlicer';
import { IAuthResponse, sxfw, sxlogin } from '../Interfaces';
import { Box, Button, TextField } from '@mui/material';
import { parseJwt } from '../Helpers/JwtFunctions';

const LoginForm = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const dispatch = useAppDispatch()
  const handleSubmit = async (event:React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const creds =  {
        'username': username,
        'password': password };

    try {
      await fetch(authUrl, {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(creds)
    }).then(response => {
        if (!response.ok) {
            setError('Error')
        }
        else {
          return response.json()
        }
    }).then(res => {
      const reply = res['token']
      const req: IAuthResponse = {
        username: parseJwt(reply)['username'],
        fullname: parseJwt(reply)['fullname'],
        role: parseJwt(reply)['Role'] ,
        token: res['token'],
        isLoggedIn: true
      }
      dispatch(signIn(req))

    })

      // Authentication successful, handle further logic
      console.log('Login successful');
    } catch (error) {
      setError('Authentication failed');
      console.error('Authentication failed:', error);
    }
  };


  return (
    <div>
      <form onSubmit={handleSubmit}>
      <h2 >Anmeldung</h2>
      <Box sx={sxfw}>
          <TextField sx={sxlogin} style={{color: 'white'}}
            label="Nutzer" size='small'
            type="text"
            id="username"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            required
            InputLabelProps={{
              shrink: true, style: {
              }
            }}
          /></Box><Box sx={sxfw}>
        <TextField sx={sxlogin}
            label="Passwort" size='small'
            type="password"
            id="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
            InputLabelProps={{
              shrink: true, style: {
              }
            }}

          /><br />
          <label className='errorText' >{error}</label></Box>
          <Box sx={sxfw}>
        <Button type="submit" variant='contained' size='small' >Login</Button></Box>
      </form>
    </div>
  );
};

export default LoginForm;
